import { render, staticRenderFns } from "./CateringPage.vue?vue&type=template&id=2e81f2af&scoped=true&"
import script from "./CateringPage.vue?vue&type=script&lang=js&"
export * from "./CateringPage.vue?vue&type=script&lang=js&"
import style0 from "./CateringPage.vue?vue&type=style&index=0&id=2e81f2af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e81f2af",
  null
  
)

export default component.exports